import Entity from '../entity'

export default class Sale extends Entity<number>{
    country_id: number;
    dealer_id: number;
    study_type_id: number;
    sale_import_id: number;
    process_type_id: number;
    number: string;
    lang: string;
    vin: string;
    customer: string;
    contact: string;
    phone_city_code: number;
    cellphone: string;
    email: string;
    city_code: number;
    phone: string;
    phone_ext: string;
    city_code_2: number;
    phone_2: string;
    phone_ext_2: string;
    city_code_3: number;
    phone_3: string;
    phone_ext_3: string;
    model: string;
    model_year: number;
    address1: string;
    address2: string;
    city: string;
    postal_code: string;
    delivery_date: string;
    seller_name: string;
    service_date: string;
    service_type: number;
    assessor_name: string;
    technician_name: string;
    plate: string;
    invoice: string;
}


